import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button, Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

export const NotReviewedProgramming: React.FC = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const handleGoToReview = () => {
    navigate(`/programming/review/${clientId || ""}`);
  };

  // Need correct link
  const handleLearnMore = () => {
    // window.open("https://frontera.freshservice.com/support/home", "_blank");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] px-4 text-center gap-3">
      <Headline size="small">Programming hasn't been reviewed yet</Headline>

      <div className="flex flex-col items-center gap-1">
        <Paragraph colorType="secondary">
          Your goals and targets will appear here after you review and sync programming.
        </Paragraph>
        <Paragraph colorType="secondary">
          Start a Program Review to confirm goals, targets, and programming data before syncing to your EHR.
        </Paragraph>
      </div>

      <div className="flex flex-col items-center gap-4 mt-6">
        <Button onClick={handleGoToReview} text="Go to Program Review" appearance="primary" />

        <Button onClick={handleLearnMore} appearance="text" text="Learn More" />
      </div>
    </div>
  );
};
